import { render, staticRenderFns } from "./FooterRB.vue?vue&type=template&id=7b31a010&"
import script from "./FooterRB.vue?vue&type=script&lang=js&"
export * from "./FooterRB.vue?vue&type=script&lang=js&"
import style0 from "./FooterRB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports